var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 7.00024H22.5001C22.8979 7.00024 23.2795 6.84221 23.5608 6.5609C23.8421 6.2796 24.0001 5.89807 24.0001 5.50024C24.0001 5.10242 23.8421 4.72089 23.5608 4.43958C23.2795 4.15828 22.8979 4.00024 22.5001 4.00024H8.00012C7.6023 4.00024 7.22077 4.15828 6.93946 4.43958C6.65816 4.72089 6.50012 5.10242 6.50012 5.50024C6.50012 5.89807 6.65816 6.2796 6.93946 6.5609C7.22077 6.84221 7.6023 7.00024 8.00012 7.00024Z",
    fill: "#ff721f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 10.9998H8.00012C7.6023 10.9998 7.22077 11.1578 6.93946 11.4391C6.65816 11.7204 6.50012 12.1019 6.50012 12.4998C6.50012 12.8976 6.65816 13.2791 6.93946 13.5604C7.22077 13.8417 7.6023 13.9998 8.00012 13.9998H22.5001C22.8979 13.9998 23.2795 13.8417 23.5608 13.5604C23.8421 13.2791 24.0001 12.8976 24.0001 12.4998C24.0001 12.1019 23.8421 11.7204 23.5608 11.4391C23.2795 11.1578 22.8979 10.9998 22.5001 10.9998Z",
    fill: "#ff721f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 18H8.00012C7.6023 18 7.22077 18.158 6.93946 18.4393C6.65816 18.7206 6.50012 19.1022 6.50012 19.5C6.50012 19.8978 6.65816 20.2794 6.93946 20.5607C7.22077 20.842 7.6023 21 8.00012 21H22.5001C22.8979 21 23.2795 20.842 23.5608 20.5607C23.8421 20.2794 24.0001 19.8978 24.0001 19.5C24.0001 19.1022 23.8421 18.7206 23.5608 18.4393C23.2795 18.158 22.8979 18 22.5001 18Z",
    fill: "#ff721f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8C3.88071 8 5 6.88071 5 5.5C5 4.11929 3.88071 3 2.5 3C1.11929 3 0 4.11929 0 5.5C0 6.88071 1.11929 8 2.5 8Z",
    fill: "#ff721f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.4997C3.88071 14.4997 5 13.3805 5 11.9997C5 10.619 3.88071 9.49976 2.5 9.49976C1.11929 9.49976 0 10.619 0 11.9997C0 13.3805 1.11929 14.4997 2.5 14.4997Z",
    fill: "#ff721f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.5C3.88071 21.5 5 20.3807 5 19C5 17.6193 3.88071 16.5 2.5 16.5C1.11929 16.5 0 17.6193 0 19C0 20.3807 1.11929 21.5 2.5 21.5Z",
    fill: "#ff721f"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOrange);
export default __webpack_public_path__ + "static/media/listOrange.5baaa1495190dc1cc202a783ec410b19.svg";
export { ForwardRef as ReactComponent };